<template>
    <div id="content-main" class="allColors">
        <!-- Pageheader -->
        <div class="edt-page-header clearfix">
            <!-- Telefon -->
            <div class="edt-ph-fb col-sm-4 clearfix">
                <div>
                    <div><span class="glyphicon glyphicon-earphone"></span></div>
                    <a href="tel:00493623303810">03623 303810</a>
                </div>
                <div>
                    <audio id="gessert_musik" controls autoplay src="sound/musik_klein.mp3" type="audio/mp3">
                        Ihr Browser kann dieses Tondokument nicht wiedergeben.<br />
                        Sie können es unter
                        <a href="sound/musik_klein.mp3">diesem Link</a>
                        abrufen.
                    </audio>
                </div>
            </div>
            <!-- Telefon -->

            <div class="edt-ph-sb clearfix">
                <!-- Logo -->
                <div class="col-sm-4 col-xs-6 edt-ph-left">
                    <router-link to="/"> <img src="images/header-logo.jpg" /></router-link>
                </div>
                <!-- Logo -->

                <div class="col-sm-8 edt-ph-right">
                    <nav class="navbar navbar-default">
                        <div class="navbar-header">
                            <button type="button" class="navbar-toggle collapsed" data-toggle="collapse" data-target="#edt-ph-nav"><span class="icon-bar"></span><span class="icon-bar"></span><span class="icon-bar"></span></button>
                        </div>
                        <div class="collapse navbar-collapse" id="edt-ph-nav">
                            <ul class="nav navbar-nav">
                                <li><router-link to="/">Home</router-link></li>
                                <li class="dropdown">
                                    <a class="dropdown-toggle" data-toggle="dropdown" href="/journeyoverview" target="_self">Reisen<b class="caret"></b></a>
                                    <ul class="dropdown-menu">
                                        <li><router-link to="/journeyoverview/Mehrtagesfahrten">Mehrtagesfahrten</router-link></li>
                                        <li><router-link to="/journeyoverview/Tagesfahrten">Tagesfahrten</router-link></li>
                                    </ul>
                                </li>
                                <li><a href="#/formular/Gruppen" target="_self">Gruppenreisen</a></li>
                                <li><a href="#/formular/Gruppen" target="_self">Busanmietung</a></li>
                                <li><a href="#/article/linienverkehr" target="_self">Linienverkehr</a></li>
                                <li><a href="#/article/ueber-uns" target="_self">Über uns</a></li>
                                <li><a href="#/article/kontakt" target="_self">Kontakt</a></li>
                                <!-- <li><a href="http://www.landkreis-gotha.de/aktuelles/aktuelles-detail/news/sonderfahrten-nach-oberhof-zum-biathlon/?tx_news_pi1%5Bcontroller%5D=News&amp;tx_news_pi1%5Baction%5D=detail&amp;cHash=54496c7c3be5e2709a75515765faa8fa" target="_blank">Aktuelles</a></li> -->
                            </ul>
                        </div>
                    </nav>
                </div>
            </div>
        </div>
        <!-- Pageheader -->

        <!-- Seitliche Links -->
        <div class="edt-sidebar visible-lg">
            <div class="sidebar-item edt-orange-label">
                <p>
                    <a href="tel:00493623303810"><span class="glyphicon glyphicon-earphone"></span></a>
                </p>
                <div></div>
            </div>
            <div class="sidebar-item edt-orange-label">
                <p>
                    <a href="mailto:info@gessert-reisen.de"><span class="glyphicon glyphicon-envelope"></span></a>
                </p>
                <div></div>
            </div>
            <div class="sidebar-item edt-orange-label">
                <p>
                    <a href="#/article/kontakt"><span class="glyphicon glyphicon-book"></span></a>
                </p>
                <div></div>
            </div>
        </div>

        <!-- Seitliche Links -->

        <!-- Topbox -->
        <div class="edt-top-box clearfix">
            <!-- Carousel -->
            <div id="edt-top-carousel" class="edt-top-carousel carousel slide" data-ride="carousel" data-interval="60000">
                <!-- Slides -->
                <div class="carousel-inner" role="listbox">
                    <!-- <div class="item active">
                        <img src="images/top-slide.jpg">
                    </div>
                    <div class="item">
                        <img src="images/top-slide.jpg">
                    </div> -->
                    <!-- {$modul_slider.0.sliderhtml} -->
                </div>

                <!-- Controls -->
                <a class="left carousel-control" href="#edt-top-carousel" role="button" data-slide="prev">
                    <div class="glyphicon glyphicon-chevron-left glyphicon-menu-left" aria-hidden="true"></div>
                </a>
                <a class="right carousel-control" href="#edt-top-carousel" role="button" data-slide="next">
                    <div class="glyphicon glyphicon-chevron-right glyphicon-menu-right" aria-hidden="true"></div>
                </a>
                <!-- Controls -->
            </div>
            <!-- Carousel -->
            <div class="edt-top-sf clearfix">
                <div class="edt-top-sf-t clearfix">
                    <div class="edt-top-sf-t-item col-md-3 col-sm-6 col-xs-12 clearfix"></div>
                </div>

                <div class="reisefinder">
                    <div class="edt-top-sf-box clearfix">
                        <div class="col-md-10 clearfix">
                            <div class="col-md-4 col-sm-6 edt-top-sf-box-line clearfix">
                                <div class="col-xs-12">
                                    <div class="edt-top-sf-box-label">
                                        <p>REISE SUCHEN <span class="glyphicon glyphicon-search"></span></p>
                                        <div class="edt-top-sf-box-label-bg"></div>
                                    </div>
                                </div>
                                <div class="col-xs-12">
                                    <div class="form-group">
                                        <input placeholder="SUCHEN" type="text" class="form-control suchbox" name="suchbox" v-model="search.search" @keyup.enter="searchJourney" />
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-4 col-sm-6 edt-top-sf-box-line clearfix">
                                <div class="form-group select-box">
                                    <!-- {{JourneyCountryStore}} -->

                                    <select name="reiseziel" class="reiseziel form-control" v-model="search.country">
                                        <option value="">LAND</option>
                                        <option disabled>---------------------------</option>
                                        <option v-for="country in journeyCountries" :key="country.id_loc_country" :value="country.id_loc_country">{{ country.name }}</option>
                                    </select>
                                </div>

                                <div class="form-group select-box">
                                    <select name="reiseart" class="reiseart form-control" v-model="search.category">
                                        <option value="" selected>KATEGORIE</option>
                                        <option disabled>---------------------------</option>
                                        <option v-for="category in journeyCategories" :key="category.id_jrn_category" :value="category.id_jrn_category">{{ category.name }}</option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-md-4 edt-top-sf-box-line clearfix">
                                <div class="input-group edt-datepicker">
                                    <input id="datepicker-start" placeholder="DATUM VON" type="text" name="anreise" class="anreise form-control" v-model="search.datefrom" @keyup.enter="searchJourney" />
                                    <span class="input-group-addon">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                                <div class="input-group edt-datepicker">
                                    <input id="datepicker-end" placeholder="DATUM BIS" type="text" name="abreise" class="abreise form-control" v-model="search.datetill" @keyup.enter="searchJourney" />
                                    <span class="input-group-addon">
                                        <span class="glyphicon glyphicon-calendar"></span>
                                    </span>
                                </div>
                            </div>
                        </div>
                        <div class="col-md-2">
                            <button class="btn btn-warning form-control" @click="searchJourney">SUCHEN</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- Topbox -->

        <!-- Content -->
        <div class="edt-cont-box clearfix">
            <ContentContainer :search="search"></ContentContainer>
        </div>
        <!-- Content -->

        <!-- Footer -->
        <div class="edt-footer-box edt-bg-blue">
            <div class="clearfix">
                <div class="col-sm-6">
                    <p>Omnibus- und Güterverkehr Gessert oHG</p>
                    <!-- <p>Klaus Gessert e.K.</p> -->
                    <p>Am Steiger 3</p>
                    <p>99894 Friedrichroda</p>
                </div>
                <div class="col-sm-4 edt-footer-trg">
                    <p>
                        <a href="https://de-de.facebook.com/gessert.reisen/" target="_blank"><img src="images/ftr-facebook.png" />Facebook</a>
                    </p>
                    <p>
                        <a href="mailto:info@gessert-reisen.de"><img src="images/ftr-envelope.png" />E-Mail</a>
                    </p>
                </div>
                <div class="col-sm-2 edt-footer-trg">
                    <p><a href="#/article/impressum">Impressum</a></p>
                    <p><a href="#/article/datenschutz">Datenschutz</a></p>
                    <p><a href="#/article/agb">AGB Reise</a></p>
                    <p><a href="#/article/AGB-Mietbus">AGB Mietbus</a></p>
                    <!-- <p><a href="pdf/Hygienekonzept_neu.pdf" target="new">Hygienekonzept</a></p> -->
                </div>
            </div>
            <p>© {{ new Date().getFullYear() }} Gessert Reisen</p>
        </div>

        <el-dialog title="Infoabende" class="edt-start-dialog" :visible.sync="dialogVisible" :before-close="handleClose">
            <p>Entdecke die faszinierenden Welten der Westküste der USA und Namibias atemberaubende Landschaften bei unseren bevorstehenden Veranstaltungen. Lass dich von unseren Reiseexperten inspirieren, erfahre Insider-Tipps und plane dein nächstes Abenteuer!</p>
            <p>Termine:<br>
                <router-link to="/journeydetail/14935">🗓️ Namibia: 10.04.2024, 18:30 Uhr</router-link><br>
                <router-link to="/journeydetail/14934">🗓️ Westküste USA: 17.04.2024</router-link><br>
            </p>
            <p>Verpasse nicht die Chance, mehr über diese aufregenden Reiseziele zu erfahren. Sichere dir jetzt deinen Platz und tauche ein in unvergessliche Erlebnisse! Anmeldungen unter: <a href="tel:+493623303810">03623 303810</a>.</p>
            <p>Wir freuen uns auf deine Teilnahme und darauf, mit dir die Vorfreude auf unvergessliche Reisen zu teilen!</p>
            <span slot="footer" class="dialog-footer">
                <el-button type="warning" @click="dialogVisible = false">Schließen</el-button>
            </span>
        </el-dialog>

        <!-- <cookie-law buttonText="Einverstanden">
            <div slot="message">
                Um Ihnen ein besseres Nutzererlebnis zu bieten, verwenden wir Cookies. Mit der Nutzung unserer Website erklären Sie sich mit der Verwendung von Cookies einverstanden. Weitere Informationen, sowie Ihre Widerspruchsmöglichkeiten finden Sie in unseren Datenschutz-Erklärung. Klicken Sie
                dazu hier. <router-link to="/article/72" style="color:#b90202; text-decoration:none;"> Datenschutz</router-link>
            </div>
        </cookie-law> -->

        <div class="journeyPopUp">
            <el-dialog :visible.sync="showJourneyPopup" width="400">
                <div class="popup-content">
                    <h2><strong>Buchen Sie jetzt die „Roland Kaiser“-Reise!</strong></h2>

                    <img src="https://lit.unisigns.de/Bilder_Druck/web/0000042528.jpg.webp" alt="Popup Image">

                    <p>Verpassen Sie nicht die Chance! Es sind noch einige Restplätze für unsere exklusive „Roland Kaiser“-Reise verfügbar – nur bis zum <strong>01.06.2024!</strong></p>
                    
                    <div class="buttonContainer">
                        <button class="btn-warning" @click="closeJourneyPopUp()">Schließen</button>
                        <button class="btn-warning" @click="goToJourney()">Zur Reise</button>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
import TopNavi from "@/components/TopNavi.vue";
import ContentContainer from "@/components/ContentContainer.vue";
// import CookieLaw from "vue-cookie-law"
import { mapState } from "vuex";

export default {
    computed: {
        ...mapState(["JourneyCategoryStore", "CountryStore", "JourneyCountryStore"]),
        journeyCategories() {
            return this.JourneyCategoryStore;
        },
        journeyCountries() {
            return this.JourneyCountryStore;
        },
    },
    name: "container",
    data() {
        return {
            showslider: true,
            search: {
                search: "",
                country: "",
                category: "",
                datefrom: "",
                datetill: "",
            },
            countries: [{ name: "Deutschland" }, { name: "Österreich" }],
            dialogVisible: false,
            showJourneyPopup: false,
        };
    },
    components: {
        TopNavi,
        ContentContainer,
        // CookieLaw
    },
    mounted() {
        setTimeout(() => {
            if (core.router.history.current.path !== "/") {
                this.showslider = false;
            } else {
                // this.showJourneyPopup = true;
            }
        }, 1000);
        // this.dialogVisible = true;
    },
    methods: {
        setTopSliderTop() {
            this.showslider = false;
        },
        searchJourney() {
            core.navigate({ path: `/journeyoverview/search/${this.search.search}` });
        },
        handleClose(done) {
            done();
        },
        closeJourneyPopUp() {
            this.showJourneyPopup = false;
        },
        goToJourney() {
            this.showJourneyPopup = false;
            core.navigate({ path: "/journeydetail/12899" });
        },
    },
};
</script>

<style>
@media (max-width: 800px) {
    .edt-start-dialog .el-dialog{
        width: 90% !important;
    }
}

.journeyPopUp .el-dialog {
    width: 410px;
}
.journeyPopUp .el-dialog__body {
    word-break: normal !important;
}

.popup-content {
    padding: 0 12px;
    border-radius: 5px;
    text-align: center;
}

.popup-content h2 {
    margin-top: 0;
    font-size: 22px;
}
.popup-content p {
    font-size: 16px;
}
.popup-content img {
    max-width: 100%;
    margin-bottom: 10px;
}
.popup-content .buttonContainer {
    display: flex;
    justify-content: space-around;
}
.popup-content button {
    margin-top: 10px;
    padding: 6px 12px;
    border: 0;
    text-transform: uppercase;
    font-size: 14px;
    font-weight: bold;
}

</style>



